import { render } from "./petsintroductionComponent.vue?vue&type=template&id=284e1e71"
import script from "./petsintroductionComponent.vue?vue&type=script&lang=js"
export * from "./petsintroductionComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__